import { Store } from 'src/store/index';

const isPublicDesign = (store: Store) => store.design.isPublic;

export default isPublicDesign;
